"use strict";
function u(n) {
  return function(t) {
    return n.apply(null, t);
  };
}
export {
  u as default
};
//# sourceMappingURL=index.es156.js.map
